import { useState } from "react";
import ResultSearchChannel from "./ResultSearchChannel";

function SearchChannelName({ channelName }) {

    const [text, setText] = useState("")
    const [CN, setCN] = useState(channelName)

    const clickHandler = (value) => {
        setCN(value)
        console.log(value)
        setText("")
    }

    return (
        <div className="flex flex-row-reverse items-center mb-4">
            <p className="w-28 text-right"> : نام کانال</p>
            <div className="bg-white border border-slate-200 flex flex-row-reverse items-center rounded p-1 relative ">
                <input
                    placeholder={CN}
                    className="w-80 p-1 rounded text-right focus:outline-none ml-5"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                />
                <img
                    src="/image/icon/searchIcon.png"
                    className="w-8 bg-white p-1"
                />
                <ResultSearchChannel text={text} clickHandler={clickHandler} />
            </div>
        </div>
    )
}
export default SearchChannelName;